export default "__VITE_ASSET__Qa9OJBb6__"